import { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel
} from '@mui/material';
import { capitalizeString } from '../../../../../utils/strings/capitilize';
import { formatToYYYYMMDDHHMM } from '../../../../../utils/dateFormatter';
import { H6, Body1 } from '../../../../../themes/typography';
import '../../../../../styles/components/Invitation.css';

function InvitationsList({
    invitations = []
}) {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [data, setData] = useState(invitations);

    const handleSort = () => {
        const isAsc = orderBy === 'name' && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy('name');

        const sortedData = [...data].sort((a, b) => {
            if (newOrder === 'asc') {
                return a['name'].localeCompare(b['name']);
            } else {
                return b['name'].localeCompare(a['name']);
            }
        });

        setData(sortedData);
    };

    useEffect(() => {
        setData(invitations);
    }, [invitations]);

    return (
        <div className="invitation-list-container">
            <TableContainer sx={tableContainerStyle}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead sx={dataCellStyle}>
                        <TableRow sx={dataCellStyle}>

                            <TableCell align="left" sx={headerCellStyle}>
                                <H6>No.</H6>
                            </TableCell>

                            <TableCell align="left" sx={headerCellStyle}>
                                <TableSortLabel
                                    direction={order}
                                    active={orderBy === 'name'} // to hide the sort icon and only show on
                                    onClick={handleSort}
                                    sx={{
                                        gap: '0.5rem',
                                        '& .MuiTableSortLabel-icon': {
                                            color: 'var(--secondary-color) !important'
                                        }
                                    }}
                                >
                                    <H6>Name</H6>
                                </TableSortLabel>
                            </TableCell>

                            <TableCell align="left" sx={headerCellStyle}>
                                <H6>Email</H6>
                            </TableCell>

                            <TableCell align="center" sx={headerCellStyle}>
                                <H6>Phone</H6>
                            </TableCell>

                            {/* <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Invite Code</H6>
                                </TableCell> */}

                            <TableCell align="center" sx={headerCellStyle}>
                                <H6>Sent on</H6>
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row, index) => (
                            <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                                sx={{
                                    borderBottom: '1px solid rgba(153, 166, 173, 0.35)'
                                }}
                            >
                                <TableCell align="left" sx={dataCellStyle}>
                                    <Body1>{index + 1}</Body1>
                                </TableCell>

                                <TableCell align="left" sx={dataCellStyle}>
                                    <Body1>
                                        {capitalizeString(row?.name, true)}
                                    </Body1>
                                </TableCell>

                                <TableCell
                                    align="left"
                                    sx={{ ...dataCellStyle, maxWidth: '320px' }}
                                    className='text-overflow-email-invite'
                                >
                                    <Body1>
                                        {row?.email}
                                    </Body1>
                                </TableCell>

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body1>{row?.phone}</Body1>
                                </TableCell>

                                {/* <TableCell align="center" sx={dataCellStyle}>
                                        <Body2>{row?.inviteCode}</Body2>
                                    </TableCell> */}

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body1>{formatToYYYYMMDDHHMM(row.created_at)}</Body1>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default InvitationsList;

const tableContainerStyle = {
    borderTopRightRadius: '1rem',
    borderTopLeftRadius: '1rem',
    maxHeight: '70vh'
};

const headerCellStyle = {
    backgroundColor: '#283853',
    borderBottom: 'none'
};

const dataCellStyle = {
    borderBottom: '1px solid var(--divider-color)'
};